import * as React from "react"
const SvgMicrophone = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 14.571a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 9 11.571v-6q0-1.25.875-2.125A2.9 2.9 0 0 1 12 2.571q1.25 0 2.125.875.875.876.875 2.125v6q0 1.25-.875 2.125a2.9 2.9 0 0 1-2.125.875m-1 6v-2.075a6.8 6.8 0 0 1-3.937-1.95q-1.638-1.625-1.988-3.95a.87.87 0 0 1 .225-.725q.275-.3.7-.3c.425 0 .52.096.713.288q.287.288.387.712a4.8 4.8 0 0 0 1.738 2.875A4.88 4.88 0 0 0 12 16.571q1.8 0 3.175-1.137a4.87 4.87 0 0 0 1.725-2.863q.1-.424.388-.712A.97.97 0 0 1 18 11.57q.425 0 .7.3t.225.725a6.98 6.98 0 0 1-1.975 3.925q-1.625 1.65-3.95 1.975v2.075a.97.97 0 0 1-.287.713.97.97 0 0 1-.713.287.97.97 0 0 1-.712-.287.97.97 0 0 1-.288-.713Zm1-8a.97.97 0 0 0 .713-.287.97.97 0 0 0 .287-.714v-6a.97.97 0 0 0-.287-.712A.97.97 0 0 0 12 4.57a.97.97 0 0 0-.712.288.97.97 0 0 0-.288.712v6q0 .426.288.713a.96.96 0 0 0 .712.287Z" />
  </svg>
)
export default SvgMicrophone
